module.exports = __webpack_public_path__ + "img/light_off.97fdc286.png";